module.exports = __webpack_public_path__ + "img/The Republic of North Macedonia.e5860d5a.gif";